import { render, staticRenderFns } from "./editShop.vue?vue&type=template&id=d37071aa&scoped=true"
import script from "./editShop.vue?vue&type=script&lang=js"
export * from "./editShop.vue?vue&type=script&lang=js"
import style0 from "./editShop.vue?vue&type=style&index=0&id=d37071aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37071aa",
  null
  
)

export default component.exports